import { render, staticRenderFns } from "./ProductManual.vue?vue&type=template&id=8985d9be&"
import script from "./ProductManual.vue?vue&type=script&lang=js&"
export * from "./ProductManual.vue?vue&type=script&lang=js&"
import style0 from "./ProductManual.vue?vue&type=style&index=0&id=8985d9be&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports